export default __webpack_public_path__ + "static/media/Sentinel.b35b8c76.png";